// Types
import mixins from "vue-typed-mixins";
// Mixins
import { WithRefs } from '../../utils/withRefs';
const refs = WithRefs();

// @ts-ignore
import { directive } from 'v-click-outside';

// @ts-ignore
import { FadeTransition } from 'vue2-transitions';

// Event used to close one modal if the other one with the same group prop was opened
const HIDE_MENU_EVENT = 'hide-menu';
const CmsAltMenu = mixins(refs).extend({
  name: 'CmsAltMenu',
  directives: {
    'click-outside': directive
  },
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clickOutsideWhitelist: {
      type: String,
      default: ''
    },
    closeOnContentClick: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'div'
    },
    disableClickOutside: {
      type: Boolean,
      default: false
    },
    group: {
      type: String,
      default: ''
    },
    // By default, v-show is being use
    useVIfDirective: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      opener: null,
      content: [],
      isOpened: false,
      position: {}
    };
  },
  async mounted() {
    this.content = this.$slots.default || [];

    // TODO: tie it all together with a service or something
    // this.$nuxt.$on(HIDE_MENU_EVENT, this.handleHideMenuEvent)
  },

  beforeDestroy() {
    this.attachContent();
    this.$nuxt.$off(HIDE_MENU_EVENT);
  },
  methods: {
    // Close one modal if the other one with the same group prop was opened
    handleHideMenuEvent({
      group,
      caller
    }) {
      this.isOpened && caller !== this && group === this.group && this.close();
    },
    activatorClicked() {
      var _this$opener, _this$opener$elm;
      (_this$opener = this.opener) === null || _this$opener === void 0 ? void 0 : (_this$opener$elm = _this$opener.elm) === null || _this$opener$elm === void 0 ? void 0 : _this$opener$elm.removeEventListener('click', this.activatorClicked);
      if (this.disabled) return;
      this.$nuxt.$emit(HIDE_MENU_EVENT, {
        group: this.group,
        caller: this
      });
      this.$nuxt.$on(HIDE_MENU_EVENT, this.handleHideMenuEvent);
      this.isOpened = true;
      this.position = this.calculatePosition();
      this.$nextTick(() => {
        this.detachContent();
      });
    },
    close() {
      this.isOpened = false;
      this.$nuxt.$off(HIDE_MENU_EVENT);
      // If it successfully closed, return true
      return !this.isOpened;
    },
    async emitStatus() {
      await this.$nextTick();
      this.isOpened ? this.$emit("opened") : this.$emit("closed");
    },
    calculatePosition() {
      var _this$opener2, _this$$refs$content, _this$$refs$content2;
      const openerEl = (_this$opener2 = this.opener) === null || _this$opener2 === void 0 ? void 0 : _this$opener2.elm;
      if (!openerEl) return;
      const directions = {
        downwards: 1,
        upwards: 2,
        toTheRight: 3,
        toTheLeft: 4
      };
      Object.freeze(directions);
      let dropdownDirection = directions.downwards;
      let dropdownXDirection = directions.toTheRight;
      const dropdownElHeight = ((_this$$refs$content = this.$refs.content) === null || _this$$refs$content === void 0 ? void 0 : _this$$refs$content.offsetHeight) || 0;
      const dropdownElWidth = ((_this$$refs$content2 = this.$refs.content) === null || _this$$refs$content2 === void 0 ? void 0 : _this$$refs$content2.offsetWidth) || 0;
      const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      const openerElRect = openerEl.getBoundingClientRect();
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const openerElWidth = openerElRect.width;
      const openerElHeight = openerElRect.height;
      const spaceToTheRightOfOpener = viewportWidth - openerElRect.left - openerElWidth;
      if (openerElRect.top > dropdownElHeight) {
        dropdownDirection = directions.upwards;
      }
      if (spaceToTheRightOfOpener < dropdownElWidth) {
        dropdownXDirection = directions.toTheLeft;
      }
      let dropdownLeftPosition;
      if (dropdownXDirection === directions.toTheRight) {
        dropdownLeftPosition = this.fixed ? openerElRect.left + scrollLeft : openerElRect.left;
      } else {
        dropdownLeftPosition = this.fixed ? openerElRect.left + openerElWidth - dropdownElWidth : Math.min(openerElRect.left + openerElWidth, viewportWidth - 33) - dropdownElWidth;
      }
      let dropdownTopPosition;
      if (dropdownDirection === directions.downwards) {
        dropdownTopPosition = this.fixed ? openerElRect.top + openerElHeight : openerElRect.top + scrollTop + openerElHeight + 2;
      } else {
        dropdownTopPosition = this.fixed ? openerElRect.top - dropdownElHeight : openerElRect.top + scrollTop - dropdownElHeight - 2;
      }
      return {
        position: this.fixed ? 'fixed' : 'absolute',
        top: `${dropdownTopPosition}px`,
        left: `${dropdownLeftPosition > 0 ? dropdownLeftPosition : 0}px`,
        minWidth: `${openerElWidth}px`
      };
    },
    genOpener() {
      var _this$$scopedSlots$op, _this$$scopedSlots, _this$$scopedSlots$op2;
      const opener = ((_this$$scopedSlots$op = (_this$$scopedSlots = this.$scopedSlots).opener) === null || _this$$scopedSlots$op === void 0 ? void 0 : (_this$$scopedSlots$op2 = _this$$scopedSlots$op.call(_this$$scopedSlots, {
        isActive: this.isOpened
      })) === null || _this$$scopedSlots$op2 === void 0 ? void 0 : _this$$scopedSlots$op2[0]) || null;
      this.$nextTick(() => {
        var _opener$elm;
        opener === null || opener === void 0 ? void 0 : (_opener$elm = opener.elm) === null || _opener$elm === void 0 ? void 0 : _opener$elm.addEventListener('click', this.activatorClicked);
      });
      this.opener = opener;
      return opener;
    },
    genContent() {
      var _this$$scopedSlots$de, _this$$scopedSlots2;
      const baseContentValues = Object.values({
        tag: 'div',
        data: {
          ref: 'content',
          style: this.position,
          class: 'z-core-menu',
          directives: [
          // If we are using v-if, dont add v-show directive
          !this.useVIfDirective && {
            name: 'show',
            value: this.isOpened
          }, {
            name: 'click-outside',
            value: {
              handler: this.handleClickOutside,
              middleware: this.checkIfClickedActivator
            }
          }].filter(Boolean),
          on: {
            click: () => this.closeOnContentClick && this.close()
          }
        },
        children: (_this$$scopedSlots$de = (_this$$scopedSlots2 = this.$scopedSlots).default) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots2, {
          close: () => this.close(),
          reposition: () => this.position = this.calculatePosition()
        })
      });

      //@ts-ignore
      const children = [this.$createElement(...baseContentValues)];
      return this.$createElement(FadeTransition, {
        props: {
          duration: 150
        },
        on: {
          'before-enter': () => this.emitStatus(),
          'after-leave': () => this.emitStatus()
        }
      }, this.useVIfDirective ?
      // v-if enabled, v-show is disabled inside directives under baseContentValues
      this.isOpened ? children : [] :
      // v-show is enabled inside directives under baseContentValues, v-if disabled
      children);
    },
    handleClickOutside() {
      this.close();
    },
    checkIfClickedActivator(e) {
      var _this$clickOutsideWhi;
      if (this.disableClickOutside) return false;
      if (!this.isOpened) return false;
      const whiteListed = (_this$clickOutsideWhi = this.clickOutsideWhitelist) === null || _this$clickOutsideWhi === void 0 ? void 0 : _this$clickOutsideWhi.split(' ').filter(Boolean);
      const wlElement = whiteListed === null || whiteListed === void 0 ? void 0 : whiteListed.map(selector => document.querySelector(selector));
      let target = e.target;
      while (target) {
        var _this$opener3;
        if ([(_this$opener3 = this.opener) === null || _this$opener3 === void 0 ? void 0 : _this$opener3.elm, ...wlElement].filter(Boolean).includes(target)) return false;
        target = target.parentElement;
      }
      return true;
    },
    detachContent() {
      this.$nextTick(() => {
        this.position = this.calculatePosition();
        const layout = document.getElementById('__layout');
        const content = this.$refs.content;
        if (!layout || !content) return;
        layout.appendChild(content);
      });
    },
    attachContent() {
      const container = this.$refs.container;
      const content = this.$refs.content;
      if (!container || !content) return;
      container.appendChild(content);
    }
  },
  render(h) {
    return h(this.tag, {
      ref: 'container'
    }, [this.genOpener(), this.genContent()]);
  }
});
export default CmsAltMenu;